// 填空题模块
<template>
  <div style="margin-top:10px">
    <div class="issueTitle">
      <span
        >Q{{ index }}:{{ infoData.contentTitle }}({{
          $store.state.select.optionType[infoData.type].name
        }})</span
      >
    </div>
    <div style="margin:10px 10px 0px 10px">
      <el-table
        :data="infoData.investigationStatisticsSubas"
        max-height="300px"
        border
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="schoolName" label="学校" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userName" label="回答人"> </el-table-column>
        <el-table-column prop="answer" label="选项">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GapFilling',
  props: {
    infoData: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {}
  },
  methods: {
  },
}
</script>
<style scoped>
.issueTitle {
  margin-left: 20px;
  font-size: 18px;
  font-weight:bold;
}
</style>
